import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { REST_BASE_URL } from '../app.config';


@Injectable()
export class AgeService {

  constructor(private http: HttpClient) {
  }


  calculateAge(geburtsdatum: string): Observable<Age> {
    const apiUrl = REST_BASE_URL + '/visum-antrag/calculate-age';
    const params = new HttpParams().set('geburtsdatum', geburtsdatum);
    return this.http.get<Age>(apiUrl, { params });
    // return ArrayObservable.of({minValue:15, maxValue:15});
  }

}

export class Age {
  minValue: number;
  maxValue: number;
}
